function dataLayer() {
  if (!window.dataLayer) window.dataLayer = [];
  return window.dataLayer;
}

export default dataLayer();
